import { SiteTypeEnum } from '../enums';

export const accountTypes = {
  1: SiteTypeEnum.Facebook,
  2: SiteTypeEnum.Twitter,
  9: SiteTypeEnum.Instagram2,
  10: SiteTypeEnum.InMessage,
  11: SiteTypeEnum.GoogleBusinessProfile,
  12: SiteTypeEnum.WhatsApp,
  13: SiteTypeEnum.AppleBusinessChat,
  14: SiteTypeEnum.GoogleBusinessMessages,
  15: SiteTypeEnum.Trustpilot,
  16: SiteTypeEnum.Line,
  17: SiteTypeEnum.Kakaotalk,
  18: SiteTypeEnum.Linkedin,
  21: SiteTypeEnum.Tiktok,
};
